import {requestToPromise, withIndexedDbStore} from '@common/utils/indexed-db';

const DB_NAME = 'mcr-research-notes-cache';
const STORE_NAME = 'notes-pages';
const DB_VERSION = 1;
const CACHE_LIMIT = 3;

const onUpgradeNeeded = db => {
  if (!db.objectStoreNames.contains(STORE_NAME)) {
    const store = db.createObjectStore(STORE_NAME, {keyPath: 'memberKey'});
    store.createIndex('updatedAt', 'updatedAt');
  }
};

const withResearchNotesCacheStore = (mode, callback) =>
  withIndexedDbStore(
    {
      dbName: DB_NAME,
      version: DB_VERSION,
      storeName: STORE_NAME,
      mode,
      onUpgradeNeeded,
    },
    callback
  );

const getAllCacheEntries = () =>
  withResearchNotesCacheStore('readonly', store => requestToPromise(store.getAll())).catch(() => []);

const deleteCacheEntries = memberKeys =>
  withResearchNotesCacheStore('readwrite', store => {
    memberKeys.forEach(memberKey => {
      store.delete(memberKey);
    });
    return null;
  });

const pruneCache = () =>
  getAllCacheEntries().then(entries => {
    const sortedEntries = [...(entries || [])].sort((left, right) => {
      const leftUpdatedAt = left?.updatedAt || 0;
      const rightUpdatedAt = right?.updatedAt || 0;
      return rightUpdatedAt - leftUpdatedAt;
    });

    return deleteCacheEntries(sortedEntries.slice(CACHE_LIMIT).map(entry => entry.memberKey));
  });

export const getResearchNotesCacheEntry = memberKey => {
  if (!memberKey) {
    return Promise.resolve(null);
  }

  return withResearchNotesCacheStore('readonly', store =>
    requestToPromise(store.get(memberKey)).catch(() => null)
  ).catch(() => null);
};

export const setResearchNotesCacheEntry = (memberKey, {notes, meta} = {}) => {
  if (!memberKey) {
    return Promise.resolve(null);
  }

  const entry = {
    memberKey,
    notes: Array.isArray(notes) ? notes : [],
    meta: meta || {},
    updatedAt: Date.now(),
  };

  return withResearchNotesCacheStore('readwrite', store => requestToPromise(store.put(entry)))
    .then(() => pruneCache())
    .then(() => entry)
    .catch(() => null);
};
